import { supabaseClient } from "supabase/supabase";

export const queryOrganizerByID = async ({ uid }: { uid: string }) => {
  const query = supabaseClient.from("organizers").select("*").eq("uid", uid);

  const { data, error } = await query;
  if (error) {
    throw error;
  }
  return data![0];
};

export const queryOrganizerByNumericID = async ({ id }: { id: number }) => {
  const query = supabaseClient.from("organizers").select("*").eq("id", id);

  const { data, error } = await query;
  if (error) {
    throw error;
  }
  return data![0];
};
